import React, { useState } from "react";
import PreLoaderWidget from '../../../components/Loader';
import RowMensagens from "../../../components/RowMensagens";
import Viewer from 'react-viewer';

const ContMensagem = ({ paciente, mensagens, preloadMensagens, wpp, usuario, sendMessage }) => {

    const [mensagem, setMensagem] = useState('');
    const [images, setImagens] = useState([]);
    const [showImgIndex, setShowImgIndex] = useState(0);
    const [openImg, setOpenImg] = useState(false);

    const keyUp = (event) => {
        if (event.key === 'Enter') {
            sendMessage();
        }
    }

    const enviarMensagem = () => {
        sendMessage(mensagem);
        setMensagem('');
    }

    const openImagens = (img, idx) => {
        setImagens(img);
        setShowImgIndex(idx);
        setOpenImg(true);
    }

    return (
        <>
            <Viewer
                visible={openImg}
                onClose={() => setOpenImg(false)}
                images={images}
                activeIndex={showImgIndex}
                onChange={(activeImage, index) => { }}
            />

            <div className="p-2">
                {preloadMensagens ? (<PreLoaderWidget />) :
                    mensagens.map((item, index) => {
                        return (
                            <>
                                <RowMensagens
                                    card={"mensagens"}
                                    idPaciente={paciente.id}
                                    profissional={item.nome}
                                    id_medico={item.id}
                                    data={item.data_desc}
                                    mensagens={item.mensagens}
                                    usuario={usuario}
                                    item={item}
                                    openImagens={openImagens}
                                />

                                <div className="respostaOnProntuario">
                                    {wpp && !preloadMensagens != null ? (
                                        <div className="chatConversationSendMSG">
                                            <input value={mensagem} onChange={(e) => setMensagem(e.target.value)} onKeyUp={(ev) => { keyUp(ev); }} type="text" className="form-control" placeholder="Digite uma mensagem" />
                                            <button className="btn gb-button" onClick={() => { enviarMensagem(); }}><i className="fas fa-paper-plane"></i></button>
                                        </div>
                                    ) : null}
                                </div>
                            </>
                        );
                    })}
            </div>
        </>
    )
}

export default ContMensagem;